import _ from 'lodash';
import { observable, makeAutoObservable } from 'mobx';
import {MassUpdateEmployee} from 'main/stores/mass_updates';

class MassUpdateEmployeeViewModel {
  data;
  fields;
  uiState;

  constructor(json, uiState) {
    makeAutoObservable(this);

    this.data = new MassUpdateEmployee(json);
    this.uiState = uiState;

    const fields = Object.entries(this.data.fields).reduce((acc, [key, value]) => {
      acc[key] = observable.map(value);
      return acc;
    }, {});
    this.fields = observable.map(fields);

    this._mergeNewValues();
  }

  _mergeNewValues() {
    const newValues = this.uiState.massUpdate.newValues[this.data.id];
    if (!newValues) return;

    for (const [key, value] of Object.entries(newValues)) {
      if (this.fields.get(key)) this.fields.get(key).merge({newValue: value});
    }
  }

  set(field, value) {
    this.uiState.updateValue(value, this.data.id, field);
    this._mergeNewValues();
  }

  get(field, bulkEvaluator = _.identity) {
    return this.fields.get(field).merge(
      { value: this._getValue(field, bulkEvaluator) }
    );
  }

  get disabled() {
    return this.uiState.massUpdate.readOnly;
  }

  get errorMessage() {
    return this.data.errorMessage;
  }

  _getValue(attribute, bulkEvaluator) {
    const field = this.fields.get(attribute);

    if (field.has('newValue')) return field.get('newValue');

    const oldValue = field.get('oldValue');

    const bulkValue = this.uiState.massUpdate.bulkEditValues[attribute];
    if (bulkValue !== undefined) return bulkEvaluator(bulkValue, oldValue);

    return oldValue;
  }
}

export default MassUpdateEmployeeViewModel;
